export enum ENV {
  DEV = 'dev',
  PROD = 'prod',
  LOCAL = 'local',
  TEST = 'test',
}

export enum SUPPORTED_LANGUAGES {
  EN = 'en',
  AR = 'ar',
}
